/**
 * ==========================================================================
 * NIHARA LUXURY COUTURE — EDITORIAL COLLECTION LIST JS
 * Vanilla JS with IntersectionObserver Scroll Reveal & Image Loading
 * ==========================================================================
 */

(function() {
  'use strict';

  function initEditorialCollections(container) {
    if (!container) return;

    var enableAnimations = container.getAttribute('data-animate') === 'true';
    var cards = container.querySelectorAll('.editorial-card--animate');
    var images = container.querySelectorAll('.editorial-card__image');

    // 1. Image loading blur removal
    images.forEach(function(img) {
      if (img.complete && img.naturalHeight !== 0) {
        img.classList.remove('is-loading');
      } else {
        img.addEventListener('load', function() {
          img.classList.remove('is-loading');
        }, { once: true });
        img.addEventListener('error', function() {
          img.classList.remove('is-loading');
        }, { once: true });
      }
    });

    // 2. Scroll Reveal with Intersection Observer
    if (!enableAnimations || cards.length === 0) {
      cards.forEach(function(card) {
        card.classList.add('is-revealed');
      });
      return;
    }

    if ('IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, {
        root: null,
        rootMargin: '0px 0px -80px 0px',
        threshold: 0.15
      });

      cards.forEach(function(card) {
        revealObserver.observe(card);
      });
    } else {
      // Fallback for older browsers
      cards.forEach(function(card) {
        card.classList.add('is-revealed');
      });
    }
  }

  // Initialize on DOM load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      var sections = document.querySelectorAll('.editorial-collections-section');
      sections.forEach(initEditorialCollections);
    });
  } else {
    var sections = document.querySelectorAll('.editorial-collections-section');
    sections.forEach(initEditorialCollections);
  }

  // Support for Shopify Theme Editor Live Reload / Events
  document.addEventListener('shopify:section:load', function(e) {
    if (e.target && e.target.classList && e.target.classList.contains('editorial-collections-section')) {
      initEditorialCollections(e.target);
    } else if (e.target) {
      var childSection = e.target.querySelector('.editorial-collections-section');
      if (childSection) initEditorialCollections(childSection);
    }
  });

  document.addEventListener('shopify:block:select', function(e) {
    if (e.target && e.target.classList && e.target.classList.contains('editorial-card')) {
      e.target.classList.add('is-revealed');
    }
  });
})();